export default __webpack_public_path__ + "static/media/visa.0e76e95e.svg";